import Vue from 'vue';
export const toastMixin = Vue.extend({
    data() {
        return {
            toastMessage: '',
            showToast: false,
            toastTimeout: null
        };
    },
    methods: {
        showToastMessage(message, duration = 3000) {
            // ALWAYS log toast messages to console for debugging
            if (message.includes('❌') || message.toLowerCase().includes('fail') || message.toLowerCase().includes('error')) {
                console.error('[Toast] 🔴', message);
            }
            else if (message.includes('✅') || message.toLowerCase().includes('success')) {
                console.log('[Toast] 🟢', message);
            }
            else {
                console.info('[Toast] 🔵', message);
            }
            // Clear existing timeout
            if (this.toastTimeout) {
                clearTimeout(this.toastTimeout);
            }
            this.toastMessage = message;
            this.showToast = true;
            this.toastTimeout = setTimeout(() => {
                this.showToast = false;
                this.toastMessage = '';
            }, duration);
        },
        hideToast() {
            if (this.toastTimeout) {
                clearTimeout(this.toastTimeout);
                this.toastTimeout = null;
            }
            this.showToast = false;
            this.toastMessage = '';
        }
    },
    beforeDestroy() {
        if (this.toastTimeout) {
            clearTimeout(this.toastTimeout);
        }
    }
});
